module.exports = __webpack_public_path__ + "img/operation.b650bce0.png";